import { Tag } from '@cian/components';
import * as React from 'react';

import { EHouseLineType } from '../../../../json_query';
import { IHouseLineBuildingTag } from '../../../state/tags/definitions/house_line.building';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IHouseLineBuildingTagProps {
  tag: IHouseLineBuildingTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const houseLineBuildingMap = {
  [EHouseLineType.First]: 'Первая линия домов (здание)',
  [EHouseLineType.Second]: 'Вторая линия домов (здание)',
};

export const HouseLineBuildingTag = (props: IHouseLineBuildingTagProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {houseLineBuildingMap[props.tag.value]}
    </TagComponent>
  );
};
